export const LOADED_BOOK = "book/loaded";
export const ADD_BOOK = "book/add";
export const REMOVE_BOOK = "book/remove";
export const UPDATE_BOOK = "book/update";